export class SelectOption {
    value: string;
    label: string;
}

export class OutgoingEventHybridModel {
    model: any[];
    formBuilderConfig: any;
}

export class ExtraDataConfig {
    editInModal: boolean;
    saveAsObject: boolean;
    cmpRelation: { label: string; value: string }[];
    posIf?: string[];
    showTabs: boolean;
}

export function buildModel(productHybrid: any[], optionsPostIf: SelectOption[]): OutgoingEventHybridModel {
    return {
        model: productHybrid,
        formBuilderConfig: {
            eventId: {
                DisplayText: 'Event ID',
                DataType: 'String',
            },
            eventName: {
                DisplayText: 'Event Name',
                DataType: 'String',
            },
            postIf: {
                DisplayText: 'Post If',
                DataType: 'String',
                SelectOptions: optionsPostIf
            },
            enabled: {
                DisplayText: 'Enabled',
                DataType: 'Boolean'
            },
        }
    };
}

export function buildExtraData(cmpRelation: { label: string; value: string }[]): ExtraDataConfig {
    return {
        editInModal: true,
        saveAsObject: true,
        cmpRelation,
        showTabs: true,
    };
}

export class OutgoingEventItem {
    eventName: string | null;
    postIf: string | null;
    enabled?: boolean | string;
}

export class HybridDataModel {
    product: any[];
    productHybrid: any[];
    productNonHybrid: any[];
    //cmpRelation?: { label: string; value: string }[];

    constructor(data?: Partial<HybridDataModel>) {
        this.product = data?.product ?? [];
        this.productHybrid = data?.productHybrid ?? [];
        this.productNonHybrid = data?.productNonHybrid ?? [];
        //this.cmpRelation = data?.cmpRelation ?? [];
    }
}

export class HybridTabConfig {
    hybridData: HybridDataModel;
    cmpRelation?: { label: string; value: string }[];
    optionsPostIf: SelectOption[];

    constructor(
        hybridData = new HybridDataModel(),
        cmpRelation: { label: string; value: string }[] = [],
        optionsPostIf: SelectOption[] = [
            { value: 'Always', label: 'Always' },
            { value: 'Open', label: 'Open' },
            { value: 'Closed', label: 'Closed' }
        ]
    ) {
        this.hybridData = hybridData;
        this.cmpRelation = cmpRelation;
        this.optionsPostIf = optionsPostIf;
    }
}

export type HybridTabName = 'product' | 'productHybrid' | 'productNonHybrid';

export const HYBRID_TAB_NAMES: HybridTabName[] = ['product', 'productHybrid', 'productNonHybrid'];

export const HYBRID_TAB_DISPLAY_NAMES: Record<HybridTabName, string> = {
    product: "Product Hybrid",
    productHybrid: "Product Hybrid (Sibling)",
    productNonHybrid: "Product Non-Hybrid"
};
